import Extend from 'flarum/common/extenders';
import VendorProductsPage from './components/VendorProductsPage';
import CheckoutPage from './components/CheckoutPage';
export default [new Extend.Routes() //
.add('abdulrehman-shop.vendor', '/vendor/products', VendorProductsPage).add('abdulrehman-shop.checkout', '/checkout', CheckoutPage)];